import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Page404Component } from './page-404/page-404.component';



@NgModule({
  declarations: [
    Page404Component
  ],
  imports: [
    CommonModule
  ],
  exports: [
    Page404Component
  ]
})
export class PageModule { }
